export default {
    apiKey: "AIzaSyB1AAPKmi6FohB2C4hSAjZY2zq_hC4ZmlA",
    authDomain: "vue-prod-f0848.firebaseapp.com",
    databaseURL: "https://vue-prod-f0848.firebaseio.com",
    projectId: "vue-prod-f0848",
    storageBucket: "vue-prod-f0848.appspot.com",
    messagingSenderId: "907552871662",
    appId: "1:907552871662:web:febe6d69132bcdc3f80fff",
    measurementId: "G-P4E5SE0WVF"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js